module.exports = __webpack_public_path__ + "static/media/buy_req_help_13.6c08cba7.png";